module.exports = __webpack_public_path__ + "static/media/BrixSans-Light-Italic.32e92ad3.woff";